import repo from '@repo/repo'
import { AGENT_LOGIN, CONNECT_AGENT, DISCONNECT_AGENT, LOAD_AGENT_CONNECTION, LOAD_AGENT_CONVERSATIONS, LOAD_CONVERSATIONS, LOAD_MESSAGES } from './_actions'
import { SET_AGENT, SET_CONVERSATIONS, SET_LOGING_IN_PROGRESS, SET_MESSAGES, SET_AGENT_CONNECTION } from './_mutations'

export default {
    async [AGENT_LOGIN]({ commit, rootGetters }) {
        try {
            const userId = rootGetters.currentUser.id
            const { data } = await repo.get(`users/${userId}/agent`)
            const { error, agent } = data
            if (error) return toastr.error(error)

            commit(SET_AGENT, agent)
            return agent
        } catch (error) {
            toastr.error(`Ocurrió un error al intentar iniciar sesión como agente: ${error.message}`)
        } finally {
            commit(SET_LOGING_IN_PROGRESS, false)
        }
    },
    async [LOAD_AGENT_CONVERSATIONS]({ commit, getters }) {
        if (!getters.agent) return

        const { data } = await repo.get(`agents/${getters.agent.id}/conversations`)

        const { conversations } = data

        commit(SET_CONVERSATIONS, conversations)

        return conversations
    },
    async [LOAD_CONVERSATIONS]({ commit, getters }) {
        // TODO: conversaciones para los coordinadores que ven las de varios agentes
    },
    async [LOAD_MESSAGES]({ commit }, from) {
        const { data } = await repo.get(`chat/messages`, {
            from,
            hasAgent: 1,
            sortBy: 'created_at',
            sortDir: 'desc',
        })

        const { error, messages } = data

        if (error) return toastr.error(error)

        commit(SET_MESSAGES, messages)
    },
    async [CONNECT_AGENT]({ commit, getters }) {
        const { data } = await repo.post(`agents/${getters.agent.id}/connect`)

        const { error, connection } = data

        if (error) return toastr.error(error)

        commit(SET_AGENT_CONNECTION, connection)
    },
    async [DISCONNECT_AGENT]({ commit, getters }) {
        const { data } = await repo.post(`agents/${getters.agent.id}/disconnect`)

        const { error, connection } = data

        if (error) return toastr.error(error)

        commit(SET_AGENT_CONNECTION, null)
    },
    async [LOAD_AGENT_CONNECTION]({ commit, getters }) {
        const { data } = await repo.get(`agents/${getters.agent.id}/connection`)

        const { error, connection } = data

        if (error) return toastr.error(error)

        commit(SET_AGENT_CONNECTION, connection)
    },
}
